import { render, staticRenderFns } from "./ItemOptions.vue?vue&type=template&id=1ca0c686&"
import script from "./ItemOptions.vue?vue&type=script&lang=js&"
export * from "./ItemOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports